import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'js/components/system/App';
import { Maintenance } from 'js/components/system/Maintenance';

import { AppRouter } from './components/AppRouter';
import { LanguageRouter } from './components/LanguageRouter';
import { RedirectRouter } from './components/RedirectRouter';

export const Router = () => (
    <BrowserRouter>
        <LanguageRouter>
            <Maintenance>
                <HelmetProvider>
                    <App>
                        <RedirectRouter>
                            <AppRouter/>
                        </RedirectRouter>
                    </App>
                </HelmetProvider>
            </Maintenance>
        </LanguageRouter>
    </BrowserRouter>
);
